import storeType from "../../../types/store";

const sampleStore: storeType = {
  weather: {
    current: 2,
    forecast: 4,
  },
  query: "",
  loading: true,
  section: "none",
  dockItem: undefined,
  date: ["0", "0"],
  selected: undefined,
  failed: false,
  booting: true,
  soundPlayed: false,
  onTop: "wallpaper",
  settings: {
    open: false,
    animations: true,
    color: "blue",
    notch: false,
    airdrop: true,
    wallpaper: {
      open: false,
      src: "../../resources/images/catalina.jpg",
      preview: "../../resources/images/preview_catalina.jpg",
      name: "Catalina",
      surname: "catalina",
    },
  },
};

export default sampleStore;
